module.exports = __webpack_public_path__ + "static/media/LOGO.f6c7441d.png";